import { render, staticRenderFns } from "./SpareInventoryList.vue?vue&type=template&id=b6a63344&scoped=true"
import script from "./SpareInventoryList.vue?vue&type=script&lang=js"
export * from "./SpareInventoryList.vue?vue&type=script&lang=js"
import style0 from "./SpareInventoryList.vue?vue&type=style&index=0&id=b6a63344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a63344",
  null
  
)

export default component.exports